import React from 'react';
import { API_BASE_URL } from '../config';

// Key used to remember which protected URL the user originally requested so
// we can send them back there after a successful login via Google OAuth.
const POST_LOGIN_REDIRECT_KEY = 'rtg.postLoginRedirect';

/**
 * Snapshot the current path + search + hash IF it is an in-app, non-root URL
 * that's safe to bounce back to (no protocol-relative or absolute hrefs).
 */
function rememberCurrentLocationForLogin() {
  try {
    if (typeof window === 'undefined') return;
    const { pathname, search, hash } = window.location;
    // Only remember protected sub-routes; "/" is the default landing already.
    if (!pathname || pathname === '/' || pathname === '') return;
    // Must be an in-app relative path. Reject anything that doesn't start
    // with a single forward slash to avoid open-redirect tricks.
    if (!pathname.startsWith('/') || pathname.startsWith('//')) return;
    const target = `${pathname}${search || ''}${hash || ''}`;
    window.sessionStorage.setItem(POST_LOGIN_REDIRECT_KEY, target);
  } catch {
    /* sessionStorage may be unavailable; just skip — fall back to '/'. */
  }
}

export default function LoginPage() {
  const searchParams = new URLSearchParams(typeof window !== 'undefined' ? window.location.search : '');
  const domainError = searchParams.get('error') === 'domain_not_allowed';

  // The user landed on the login screen via a protected route (e.g. /admin).
  // Snapshot the URL on mount so a later post-login bounce returns them here.
  React.useEffect(() => {
    rememberCurrentLocationForLogin();
  }, []);

  const handleGoogleLogin = () => {
    rememberCurrentLocationForLogin();
    window.location.href = `${API_BASE_URL}/auth/google`;
  };

  return (
    <div style={{
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      minHeight: '100vh',
      background: 'var(--secondary-color)',
      padding: '20px'
    }}>
      <div style={{
        textAlign: 'center',
        background: 'white',
        padding: '60px 80px',
        borderRadius: '16px',
        boxShadow: 'var(--shadow-lg)',
        maxWidth: '500px',
        width: '100%'
      }}>
        <img
          src="/images/rtg-logo-red.png"
          alt="RTG"
          style={{
            height: '56px',
            width: 'auto',
            marginBottom: '8px',
            objectFit: 'contain'
          }}
        />
        <p style={{
          fontSize: '18px',
          color: 'var(--text-light)',
          marginBottom: '40px',
          fontWeight: '500'
        }}>
          Employee Nexus
        </p>
        {domainError && (
          <div style={{
            marginBottom: '20px',
            padding: '12px 16px',
            background: '#FEE2E2',
            color: '#991B1B',
            borderRadius: '8px',
            fontSize: '14px'
          }}>
            Your email domain is not allowed. Only whitelisted company domains can sign in.
          </div>
        )}
        <button
          onClick={handleGoogleLogin}
          type="button"
          className="login-google-btn"
          aria-label="Sign in with Google"
          style={{
            padding: 0,
            border: 'none',
            background: 'transparent',
            cursor: 'pointer',
            display: 'block',
            margin: '0 auto'
          }}
        >
          <img
            src="/images/btn_google_signin_light.svg"
            alt="Sign in with Google"
            style={{
              height: '44px',
              width: 'auto',
              display: 'block'
            }}
          />
        </button>
      </div>
    </div>
  );
}
